import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import {
  Accordion,
  AccordionDetails,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
  Box,
} from "@mui/material";
import AdvanceSearch from "../../CommonComponents/AdvanceSearch";
import ErrorBoundary from "../../ErrorBoundry";
import TelerikDataTable from "../../CommonComponents/TelerikDataTable";
import { useNavigate } from "react-router-dom";
import { useAuth } from "oidc-react";
import { filterAllowedColumn } from "../../_helper/helper";
import { Icon } from "@progress/kendo-react-common";
import visileColumns from "./visibleColumns";
import useSortedColumns from "../../utils/useSortedColumns";
import { getAuditHistoryData } from "../Create Transaction/slices/getDataBySSNSlice";
import DifferencesModal from "../OutsideEmployment/components/DifferencesModal";
import { loadingPanel } from "../../CommonComponents/CommonFunction";

const AuditTrailGG1 = () => {
  const dispatch = useDispatch();
  const tableName = "fn_GG1log_auditlog";
  const { userData } = useAuth();
  const history = useNavigate();

  const {
    columns,
    loadingSearch,
    ColumnsSorted,
    searchResults: { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const { pageSize: storePageSize } = useSelector(
    (state) => state.CommonReducer
  );
  const { auditHistory, isAuditLoading, HistoryDataAllColumn } = useSelector(
    (state) => state.getDataBySSNSlice
  );
  const {
      transaction: TransactionsBySSNAndAction,
      transactionProcessStatuses,
    } =
      useSelector(
        (state) => state.getDataBySSNSlice.TransactionsBySSNAndAction
      ) || {};
  const id = "auditTrailGG1Log";

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(storePageSize[id] || 100);
  //   const [sortedColumns, setSortedColumns] = useState([]);
  const [sortData, setSortData] = useState([]);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [modalchangeDateTime, setModalchangeDateTime] = useState(null);

  // --- State for the search functionality ---
  const [searchBy, setSearchBy] = useState("EmpId");
  const [searchValue, setSearchValue] = useState("");
  const [searchParams, setSearchParams] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const [differenceData, setDifferenceData] = useState([]);
  const [openDiffModal, setOpenDiffModal] = useState(false);


  const [sortedColumns, setSortedColumns] = useSortedColumns(
    id,
    ColumnsSorted,
    columns,
    visileColumns,
    userData
  );

  //   useEffect(() => {
  //     if (ColumnsSorted[id] !== undefined) {
  //       setSortedColumns(ColumnsSorted[id]);
  //     } else {
  //       if (columns && visileColumns.length > 0 && columns.length > 0) {
  //         setSortedColumns(filterAllowedColumn(userData, visileColumns), "id");
  //       }
  //     }
  //   }, [columns]);

  // --- Updated Handler for the Search button with dynamic dataType ---
  const handleSearch = () => {
    if (!searchValue.trim()) {
      alert("Please enter a search value.");
      return;
    }

    const newSearchParams = [
      {
        columnName: searchBy,
        value: searchValue,
        operator: "=",
        // Dynamically set the dataType based on the selected radio button
        dataType: searchBy === "EmpId" ? "bigint" : "varchar(MAX)",
      },
    ];

    setSearchParams(newSearchParams);
    setIsSearched(true);
  };

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };

  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
    setPageSize(100);
  };

  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
    setPageSize(100);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };
  useEffect(()=>{
    if(!modalchangeDateTime || !auditHistory || !Array.isArray(auditHistory)) return

    const findIndex =
            auditHistory &&
            auditHistory.findIndex((item) => {
              return item?.changeDateTime == modalchangeDateTime;
            });

          if (findIndex !== -1 && findIndex + 1 < auditHistory?.length) {
            const filterData = [
              auditHistory[findIndex],
              auditHistory[findIndex + 1],
            ];

            setDifferenceData(filterData);
            setOpenDiffModal(true);
          }
  },[auditHistory])

console.log(isAuditLoading,"auditHistorydata1221")


  const actions = useMemo(() => {
    return [
      {
        title: "Show Details",
        action: async (props) => {
          // const findIndex =
          //   auditHistory &&
          //   auditHistory.findIndex((item) => {
          //     return item?.changeDateTime === props?.dataItem?.changeDateTime;
          //   });

          // if (findIndex !== -1 && findIndex + 1 < auditHistory?.length) {
          //   const filterData = [
          //     auditHistory[findIndex],
          //     auditHistory[findIndex + 1],
          //   ];

          //   setDifferenceData(filterData);
          //   setOpenDiffModal(true);
          // }
          if (
            props?.dataItem?.ACTN_NO === null ||
            props?.dataItem?.ACTN_NO === undefined
          ) {
            return;
          }
          const TransactionsBySSNAndAction = props?.dataItem;
          dispatch(
            getAuditHistoryData({
              employeeId: TransactionsBySSNAndAction.EmployeeID,
              actionNo: TransactionsBySSNAndAction.ACTN_NO?.trim(),
            })
          );
          setModalchangeDateTime(props?.dataItem?.changeDateTime)
        },
        icon: { iconName: "k-icon  k-i-eye" },
        // icon: faEye,
        className: "font-primary",
        style: { cursor: "pointer" },
      },
      {
        title: "Go to Transaction",
        action: (props) => {
          const actionNo = props?.dataItem?.HR_CONTROL;
          if (actionNo) {
            if (actionNo.startsWith("NPA-")) {
              history(
                `/npa/transaction/recruitment/${actionNo}`
              );
            } else {
              history(
                `/transaction/${props?.dataItem?.EmployeeID}/${actionNo}`
              );
            }
          } else {
            console.error("Action number is not available for navigation.");
          }
        },
        icon: { iconName: "k-icon k-i-redo" }, 
        className: "font-primary",
        style: { cursor: "pointer" },
      },
    ];
  });

  useEffect(() => {
    if (!openDiffModal) {
      setDifferenceData([]);
    }
  }, [openDiffModal]);

  
  return (
    <ErrorBoundary>
    {isAuditLoading && loadingPanel()}
      <Fragment>
        <Container fluid={true}>
          <Row className="bg-primary rounded py-3 mb-3">
            <Typography variant="h5">
              <Icon
                style={{ fontSize: "25px", margin: "10px" }}
                name="file-ascx"
              />
              Audit Trail GG1
            </Typography>
          </Row>
          <Row>
            <Col sm="12" className="page-content">
              <Card>
                <CardBody>
                  <FormControl
                    component="fieldset"
                    fullWidth
                    sx={{ mb: 3, padding: "20px" }}
                  >
                    <FormLabel
                      component="legend"
                      style={{ fontWeight: "bold", fontSize: "20px" }}
                    >
                      Search By
                    </FormLabel>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flexWrap: "wrap", // Allows wrapping on smaller screens
                        mt: 1,
                      }}
                    >
                      <RadioGroup
                        row
                        name="search-by-group"
                        value={searchBy}
                        onChange={(e) => setSearchBy(e.target.value)}
                      >
                        <FormControlLabel
                          value="EmpId"
                          control={<Radio />}
                          label="Employee Id"
                        />
                        <FormControlLabel
                          value="HrControl"
                          control={<Radio />}
                          label="Hr Control"
                        />
                      </RadioGroup>
                      <TextField
                        label="Search Value"
                        variant="outlined"
                        size="small"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                      />
                      <Button
                        variant="contained"
                        onClick={handleSearch}
                        disabled={!searchValue.trim()}
                      >
                        Search
                      </Button>
                    </Box>
                  </FormControl>
                  {/* --- End: New MUI Search Form --- */}

                  {/* --- Conditional Rendering: Show table only after search --- */}
                  {isSearched && (
                    <>
                      <AdvanceSearch
                        id={tableName}
                        location={"global"}
                        columnList={"*"}
                        columnRefernces={[]}
                        tableName={tableName}
                        searchParams={searchParams}
                        forceParams={searchParams}
                        additionalWhere={additionalWhere}
                        expanded={true}
                        sortData={sortData}
                        pageNumber={page}
                        pageSize={pageSize}
                        chooseFilterMethod={chooseFilterMethod}
                        gridId={tableName}
                      />
                      <Accordion expanded={true}>
                        <AccordionDetails>
                          <>
                            {sortedColumns.length > 0 && (
                              <TelerikDataTable
                                isDashboard={true}
                                pageSize={pageSize}
                                totalCount={rowCount}
                                skip={(page - 1) * pageSize}
                                take={pageSize}
                                data={results || []}
                                sortData={sortData}
                                onFilterChange={handleFilterChange}
                                onSortChange={handleSortChange}
                                onPageChange={handlePageChange}
                                onPageSizeChange={handlePageSizeChange}
                                selectedColumns={sortedColumns}
                                setSortedColumns={setSortedColumns}
                                loading={loadingSearch}
                                id={tableName}
                                actions={actions}
                              />
                            )}
                          </>
                        </AccordionDetails>
                      </Accordion>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <DifferencesModal
            visible={openDiffModal}
            setVisible={setOpenDiffModal}
            data={differenceData?.length > 0 ? differenceData : []}
            loadingPanel={loadingPanel}
            loading={
              // differenceData &&
              // differenceData?.length > 0 
              //   ? false
              //   : true
              isAuditLoading
            }
          />
        
        </Container>
      </Fragment>
    </ErrorBoundary>
  );
};

export default AuditTrailGG1;
